/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnumProdutos } from 'models/enums'
import {
  Convenio,
  GrauReferencia,
  Paginacao,
  Pais,
  ProdutoSimulacao,
  Profissao,
  Telefone,
  TempoEmprego,
  TipoPix
} from 'models/types'
import { Tabulacao } from 'models/types'

export interface CadastroSimplificadoReq {
  nome: string
  cpf: string
  dataNascimento: string
  matricula?: string | null
  ddd: string
  telefone: string
  perfilId: string
  convenioId?: string | null
  margem?: number | null
  margemCartao?: number | null
  sessaoServidor?: boolean
  numeroNit?: number | null
}

export interface RequestValidacaoNovoAtendimentoDto {
  cpf: string
  novoAtendimento: boolean
  tipoAtendimento: number
  campanhaCrmId: string | null
  tipoProdutoEnum: number | null
  consultorCarteiraId: string | null
}

/**Tab Contato*/

export interface TabContato {
  nome: string
  dataNascimento: string
  cidade: string
  sexo: string
  tabulacoes: Tabulacao[]
  tiposAgendamentos: TipoAgendamento[]
  tipoChamada: number
  infosChamada: InfosChamada
  infosChamadaInvalid: InfosChamadaInvalid
  agendamentos?: Agendamento[]
  tabelaAtendimentos: Paginacao
  atendimentoId: string
  clienteRiber: boolean
  isOpenEnriquecimento: boolean
  enriquecido: boolean
  tipoProduto: number
  campanhaCrmId: string
  consultorId: string | null
  tipoAtendimento: number
  atendimentoAgendadoId: string | null
  integracao: ParametroIntegracao
  mensagemErroIntegracao?: string | null
  clienteSite: boolean
  modalSms: ModalSms
  modalKanban: {
    isOpen: boolean
    register: {
      pipelineId: string
      pipelineEtapaId: string
    }
  }
  isLoaded: boolean
  modalChatwoot: boolean
  optionsSelect: {
    pipelines: {
      descricao: string
      id: string
    }[]
    etapas: {
      descricao: string
      id: string
    }[]
  }
}

export interface ParametroIntegracao {
  url: string
  tipoIntegracao: 'whatsApp' | 'chatWoot' | 'molaBox' | null
}

export interface ModalSms {
  isOpen: boolean
  telefone: number
  cpf: string
  mensagem: string
  resposta?: string[] | null
  dataResposta?: string | null
  responseClient?: string[] | null
  dataResponse?: string | null
  loading: boolean
}
export interface ModalChatwoot {
  isOpen: boolean
  loading: boolean
}
export interface InboxesChatWoot {
  id: number
  name: string
}
export interface AgentesChatWoot {
  id: number
  name: string
}
export interface FinalizaAgendamentoDto {
  atendimentoId: string
  atendimentoAgendadoId: string
}

export interface TipoAgendamento {
  descricao: string
  atendimentoAgendado: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: string
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: string
}

export interface InfosChamada {
  telefones?: {
    telefoneId: string
    numero: string
    whatsapp: boolean
  }[]
  numeroChamada: string
  tabulacaoChamada: Tabulacao | null
  dataAgendamento: string
  horarioAgendamento: string
  tipoAgendamento: string
  observacoesAgendamento: string
  emChamada: boolean
  statusChamada: StatusChamadaEnum
  modalDiscagem: boolean
  numerosDiscados: string[]
  callId: string
  infosMatriculasLead: InfosMatriculaLead[]
}

export enum StatusChamadaEnum {
  naoIniciado = 0,
  discando = 1,
  atendida = 2,
  finalizada = 3,
  erro = 4
}

export interface InfosChamadaInvalid {
  dataAgendamento: boolean
  horarioAgendamento: boolean
  tipoAgendamento: boolean
}

export interface Oferta {
  descricao: string
  valor: string
}
export interface InfosMatriculaLead {
  matricula: string
  descricaoPerfil: string
  descricaoStepLead: string
  exibeMatricula: boolean
  observacaoLead: string
  produtosLead: Oferta[]
}

export interface Agendamento {
  id: string
  descricaoTabulacao?: string
  canal: string
  dataChamada: string
  duracao: string
  nomeAtendente: string
  ddd: string
  telefone: string
  index: number
  enviaSms: boolean
}

export interface Cliente {
  valorRendaIndividual: number
  profissao: any
  pessoaId: string
  margemConsignadoCartao: number
  escolaridadeId: string
  valorDesejado: any
  margemDisponivel: number
  bmg: any
  sexo: string
  estadoCivil: number
  nomeConjuge: any
  cidadeNascimento: string
  ufNascimento: string
  nacionalidade: string
  pessoa: Pessoa
  clienteMatricula: any
  convenios: any
  escolaridade: any
  abandonoCliente: any
  atendimentos: any[]
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: string
}

export interface Pessoa {
  flagJuridica: boolean
  nome: string
  cpfCnpj: string
  nomeMae: string
  nomePai: string
  dataNascimento: string
  ie: any
  im: any
  rg: string
  rgOrgaoEmissorId: string
  isento: any
  nomeFantasia: any
  estadoOrgaoEmissorId: string
  dataEmissao: string
  enderecos: any
  telefones: Telefone[]
  usuariosBancos: any[]
  formulariosAtendimento: any
  contaCorrente: any
  estadoOrgaoEmissor: any
  rgOrgaoEmissor: any
  atendimentos: any
  telefonesCondenados: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: string
}

export interface CanalAtendimento {
  descricao: string
  atendimentos: any[]
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: any
}

export interface Atendente {
  flagJuridica: boolean
  nome: string
  cpfCnpj: string
  nomeMae: string
  nomePai: string
  dataNascimento: string
  ie: any
  im: any
  rg: string
  rgOrgaoEmissorId: string
  isento: any
  nomeFantasia: any
  estadoOrgaoEmissorId: string
  dataEmissao: any
  cliente: any
  enderecos: any
  telefones: any
  usuariosBancos: any[]
  formulariosAtendimento: any
  contaCorrente: any
  estadoOrgaoEmissor: any
  rgOrgaoEmissor: any
  atendimentos: any[]
  telefonesCondenados: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: any
  dataUltimaAlteracao: any
}

export interface TabulacaoAtendimento {
  atendimentoId: string
  cpf: string
  ddd: string
  telefone: string
  tabulacaoId?: string
  dataAtendimento?: string
  horario?: string
  tipoAgendamentoId: string
  observacoes?: string
  tabulacaoAutomaticaId?: string
  tipoAtendimento: number
  tipoProduto: number
  campanhaCrmId: string
  consultorCarteiraId: string | null
  callId: string
  tabulacaoAutomatica?: boolean
}

export interface ResponseTabulacao {
  telefones: Telefone[]
  novoAtendimento: boolean
  proximoTelefone: boolean
  atendimento: ResponseAtendimentoDto | null
}

export interface ResponseAtendimentoDto {
  atendimentoId: string
  nome: string
  cpfCnpj: string
  matricula: string
  dataNascimento: string | null
  cidade: string
  sexo: string
  telefones: Telefone[]
  descricaoPerfil: string
  complemento: string
  clienteRiber: boolean
  tipoProduto: number | null
  campanhaCrmId: string | null
}

export interface InformacoesChamadaDto {
  usuarioId: string | null
  cpfCliente: string
  telefones: ResponseTelefonesDto[]
  ddd: string
  numero: string
  statusChamada: StatusChamadaEnum
  tabulacao: Tabulacao
  tipoLigacao: '1' | '2'
  callId: string
}

export interface ResponseTelefonesDto {
  ddd: string
  numero: string
}

export interface PlanoSeguroPrestamistaSelecionado {
  matricula: string
  value: number
  valorPremio: number
}
export interface SeguroPrestamistaSelecionado {
  matricula: string
  value: number
  valorSeguro: number
}
/**Tab Produto*/
export interface TabProduto {
  beneficios: Beneficio[]
  bancoValidacaoSelected: 'bmg' | 'itau'
  telefonesClienteIN100: { value: string; label: string }[]
  somatorioTotalProdutos: number
  somatorioResumo: number
  produtosDisponiveis: ProdutoSimulacao[]
  produtosSelecionados: ProdutoSimulacao[]
  outrosProdutos: any[]
  produtosContratados: ProdutosContratados[]
  detalhamentoIsOpen: boolean
  produtoSelected: {
    servico: number
    matricula: string
    produtoCrefazId?: number | null
  }
  infosClienteResumo: InfosClienteResumo
  modalResumoContratacao: boolean
  loadingSimulacao: boolean
  invalidContratacao: boolean
  modalIndicacaoManual: boolean
  clienteNaoElegivel: boolean
  modalIndicacao: boolean
  mensagemModalIndicacao: string[]
  matriculasModalIndicacao: string[]
  modalAgregacao: boolean
  modalInegibilidade: boolean
  mensagemInegibilidade: string[]
  servico: number
  matricula: string
  listProdutosRefinQtdDeParcelasOriginaisByContrato: {
    contrato: string
    value: number
  }[]
  listCodigoTabelaSelectedByCodigoSimulacao: { id: number; value: number }[]
  listParcelasSelectedByCodigoSimulacao: { id: number; value: number }[]
  margemDisponivelByMatricula: { matricula: string; value: number }[]
  listPlanoSeguroPrestamistaConsignadoSelecionadoByMatricula: PlanoSeguroPrestamistaSelecionado[]
  listPlanoSeguroPrestamistaBeneficioSelecionadoByMatricula: PlanoSeguroPrestamistaSelecionado[]
  listPlanoSeguroPrestamistaCartaoBeneficioSelecionadoByMatricula: PlanoSeguroPrestamistaSelecionado[]
  listPlanoSeguroPrestamistaCartaoConsignadoSelecionadoByMatricula: PlanoSeguroPrestamistaSelecionado[]
  modalCoberturasSeguroPrestamista: boolean
  modalSeguroSindnapi: boolean
}

export interface Beneficio {
  id: string
  numero: string
  dataAtualizacaoToken: string
  dataConsentimento: string
  dataRespostaIn100: string
  clientePerfil: ClientePerfil
  loading: boolean
  numeroNit: string | null
}

interface ClientePerfil {
  id: string
  descricao: string
  tipoPerfil: number
}

export interface InfosClienteResumo {
  nome: string
  cpf: string
  dataNascimento: string
  numeroIdentidade: string
  emissorIdentidade: string
  ufIdentidade: string
  dataEmissao: string
  nomePai: string
  nomeMae: string
  cep: string
  logradouro: string
  numeroEndereco: string
  bairro: string
  cidade: string
  uf: string
  complemento: string
  numero: string
  ddd: string
  sexo: string
  estadoCivil: string
  nomeConjuge: string
  cidadeNascimento: string
  ufNascimento: string
  nacionalidade: string
  grauInstrucao: string
  matriculas: MatriculaResumo[]
  contaCorrentePrincipal: ContaCorrentePrincipal
}

export interface ContaCorrentePrincipal {
  descricaoBanco: string
  agencia: string
  digitoAgencia: string
  conta: string
  digitoConta: string
}

export interface MatriculaResumo {
  id: string
  numeroMatricula: string
  tipoPerfil: number
  descricaoPerfil: string
  tipoPerfilId: string
  convenioId?: string
  margemDisponivel: number
  margemCartaoDisponivel: number
  margemCartaoBeneficio: number
  descricaoBanco: string
  contaCorrenteId: string
  tipoContaId: string
  bancoDadosBancariosId: string
  numeroAgencia: string
  digitoVerificadorAgencia: any
  numeroConta: string
  digitoVerificadorConta: string
}

export interface ProdutosContratados {
  cpf: string
  nomeCliente: string
  numeroProposta: string
  produto: keyof typeof EnumProdutos
  valorTotal: number
  quantidadeParcelas: number
  valorParcela: number
  valorLiberado: number
  usuarioInstituicao: any
  status: number
  banco: string
  numeroMatricula: string
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataContratacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: any
  dataUltimaAlteracao: any
}

/**Tab Informações*/

export interface TabInformacoes {
  infoCliente: InfoCliente
  invalids: CamposInfosCliente
  optionsSelect: OptionsSelect
  activeTabBeneficio: number
}

export interface InfoCliente {
  nome: string
  cpf: string
  dataNascimento: string
  nacionalidadeId: string
  nomePai?: string | null
  nomeMae: string
  numeroIdentidade: string
  orgaoEmissorId: string
  ufOrgaoEmissor: string
  dataEmissao: string
  ddd: string
  numero: string
  email?: string | null
  sexo: string
  estadoCivil: string | null
  nomeConjuge?: string | null
  cidadeNascimento: string
  ufNascimento: string
  escolaridadeId: string
  cep: string
  cidade: string
  siglaEstado: string
  logradouro: string
  numeroEndereco: string
  bairro: string
  complemento?: string | null
  profissaoId: string
  empresa?: string | null
  tempoEmpregoId?: string | null
  referencias: Referencia[]
}

export interface Matricula {
  id?: string | null
  numeroMatricula?: string | null
  tipoPerfil?: number | null
  descricaoPerfil?: string | null
  tipoPerfilId?: string | null
  convenioId?: string | null
  margemDisponivel?: string | null
  margemCartaoDisponivel?: string | null
  margemCartaoBeneficio?: string | null
  numeroNit?: string | null
}

export interface MatriculaReq {
  id?: string | null
  numeroMatricula?: string | null
  tipoPerfil?: number | null
  descricaoPerfil?: string | null
  tipoPerfilId: string
  convenioId?: string | null
  margemDisponivel?: number | null
  margemCartaoDisponivel?: number | null
  margemCartaoBeneficio?: number | null
  numeroNit?: string | null
}

export interface InfoClienteReq {
  nome: string
  cpf: string
  dataNascimento: string
  nacionalidadeId: string
  nomePai?: string | null
  nomeMae: string
  numeroIdentidade: string
  orgaoEmissorId: string
  ufOrgaoEmissor: string
  dataEmissao: string
  ddd: string
  numero: string
  email?: string | null
  sexo: string
  estadoCivil: string | null
  nomeConjuge?: string | null
  cidadeNascimento: string
  ufNascimento: string
  escolaridadeId: string
  cep: string
  cidade: string
  siglaEstado: string
  logradouro: string
  numeroEndereco: string
  bairro: string
  complemento?: string | null
  profissaoId: string
  empresa?: string | null
  tempoEmpregoId?: string | null
  referencias: Referencia[]
}
export interface CamposInfosCliente {
  nome: boolean
  cpf: boolean
  dataNascimento: boolean
  nacionalidadeId: boolean
  nomePai: boolean
  nomeMae: boolean
  numeroIdentidade: boolean
  orgaoEmissorId: boolean
  ufOrgaoEmissor: boolean
  dataEmissao: boolean
  ddd: boolean
  numero: boolean
  email: boolean
  sexo: boolean
  estadoCivil: boolean
  nomeConjuge: boolean
  cidadeNascimento: boolean
  ufNascimento: boolean
  escolaridadeId: boolean
  cep: boolean
  cidade: boolean
  siglaEstado: boolean
  logradouro: boolean
  numeroEndereco: boolean
  bairro: boolean
  complemento: boolean
  profissaoId: boolean
  empresa: boolean
  tempoEmpregoId: boolean
  referencias: ReferenciaInvalid[]
}

export interface MatriculaInvalid {
  id: boolean
  numeroMatricula: boolean
  tipoPerfil: boolean
  descricaoPerfil: boolean
  tipoPerfilId: boolean
  convenioId: boolean
  margemDisponivel: boolean
  margemCartaoDisponivel: boolean
  margemCartaoBeneficio: boolean
  numeroNit: boolean
}

export interface Referencia {
  nome: string
  ddd: string
  numero: string
  grauReferenciaCrefazId: string
}

export interface ReferenciaInvalid {
  nome: boolean
  ddd: boolean
  numero: boolean
  grauReferenciaCrefazId: boolean
}

interface Genero {
  value: string
  descricao: string
}

interface OrgaoEmissor {
  nome: string
  pessoas: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: any
}

interface Estado {
  nome: string
  sigla: string
  endereco: any
  pessoas: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: string
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: string
}

interface Escolaridade {
  numero: number
  descricao: string
  cliente: any
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: string
  dataUltimaAlteracao: string
}
interface EstadoCivil {
  value: number
  descricao: string
}

interface TipoConta {
  value: string
  descricao: string
}

interface Banco {
  id: string
  codigoBanco: string
  descricao: string
}

interface Cidade {
  nome: string
  sigla: string
  id: string
  ativo: boolean
  usuario: any
  idUsuarioCriacao: string
  dataCriacao: string
  usuarioAlteracao: any
  idUsuarioUltimaAlteracao: any
  dataUltimaAlteracao: any
}

export interface OptionsSelect {
  genero: Genero[]
  orgaoEmissor: OrgaoEmissor[]
  ufOrgaoEmissor: Estado[]
  escolaridade: Escolaridade[]
  ufNascimento: Estado[]
  cidadeNascimento: Cidade[]
  estadoCivil: EstadoCivil[]
  uf: Estado[]
  cidade: Cidade[]
  tipoConta: TipoConta[]
  banco: Banco[]
  convenios: Convenio[]
  profissoes: Profissao[]
  temposEmprego: TempoEmprego[]
  grausReferencia: GrauReferencia[]
  paises: Pais[]
}

/**Tab Matriculas*/

export interface InfosMatriculas {
  contratos: Contratos[]
  tabelaContratos: Paginacao
  infosConsig?: InfosConsig
}

export interface InfosConsig {
  nome: string
  idade: string
  valorRenda: number
  margemDisponivel: number
  margemCartaoConsignado: number
  margemCartaoBeneficio: number
  situacao: string
  especie: string
  possuiRepresentanteLegalProcurador: string
  bloqueioEmprestismo: string
  beneficioPermiteEmprestimo: string
  pensaoAlimenticia: string
  dataDespachoBeneficio: string
  idMatricula: string
  margemComplementar?: number
  convenio?: string
}

export interface Contratos {
  id: string
  matricula: string
  codigoBanco: string
  banco: string
  numeroContrato: string
  valorContrato: number
  tipoEmprestimo: string
  inicioContrato: string
  fimContrato: string
  parcelasEmAberto: number
  quantidadeParcelas: number
  valorParcela: number
  dataAverbacao: string
  situacao: string
  taxa: number
  saldoDevedorAproximado: number
  valorReservado: number
}
export interface Demonstrativo {
  nome: string
  cpf: string
  informacoesBeneficio: InformacoesBeneficio
  instituicaoPagadora: InstituicaoPagadora
  informacoesContratosEmprestimo: InformacoesContratosEmprestimo[]
  informacoesContratosCartao: InformacoesContratosCartao[]
  informacoesContratosRcc: InformacoesContratosRcc[]
}

export interface InformacoesBeneficio {
  numeroMatricula: string
  salario: number
  margemEmprestimo: number
  margemRmc: number
  margemRcc: number
  especie: string
  situacao: string
  pensaoAlimenticia: boolean
  representanteLegal: boolean
  bloqueioEmprestimo: boolean
  elegivelEmprestimo: boolean
}

export interface InstituicaoPagadora {
  codigoBanco: string
  tipo: string
  agencia: string
  contaCorrente: string
}

export interface InformacoesContratosEmprestimo {
  numeroContrato: string
  banco: string
  competenciaInicioDesconto: string
  competenciaFimDesconto: string
  dataAverbacao: string
  parcelas: string
  valorParcela: number
  valorTotal: number
  situacao: string
}

export interface InformacoesContratosCartao {
  numeroContrato: string
  banco: string
  dataInclusao: string
  situacao: string
  limite: any
  valorTotal: number
}

export interface InformacoesContratosRcc {
  numeroContrato: string
  banco: string
  dataInclusao: string
  situacao: string
  limite: any
  valorTotal: number
}

/**Tab Upload*/

export interface TabUpload {
  register: {
    tipoArquivo: string
    uploadedFile: File | null
  }
  tiposArquivo: TipoArquivo[]
  anexos: Anexo[]
  paginacaoAnexos: Paginacao
}

export interface TipoArquivo {
  value: string
  descricao?: string
}

export interface Anexo {
  id: string
  nomeArquivo: string
  descricaoTipoArquivo: string
  dataCriacao: string
  index: number
}

/** Tab Dados Bancários */

export interface TabDadosBancarios {
  dadosBancarios: DadosBancarios
  invalids: CamposDadosBancariosInvalids
  optionsSelect: OptionsSelectDadosBancarios
  dadosBancariosCadastrados: DadosBancariosCadastrados[]
  configs: ConfigTabDadosBancarios
}

export interface DadosBancarios {
  contaCorrenteId?: string | null
  numeroAgencia: string | null
  digitoAgencia?: string | null
  numeroConta: string | null
  digitoConta: string | null
  chavePix?: string | null
  tipoPixId?: string | null
  tipoContaId: string
  bancoDadosBancariosId: string
  matriculaId?: string | null
  principal: boolean
}

export interface DadosBancariosCadastrados {
  id: string
  cpf: string
  contaCorrenteId: string
  numeroAgencia: string
  digitoAgencia: string
  numeroConta: string
  digitoConta: string
  chavePix: string
  descricaoTipoPix: string
  tipoPixId: string
  descricaoTipoConta: string
  tipoContaId: string
  descricaoBancoDadosBancario: string
  bancoDadosBancarioId: string
  matricula: string | null
  matriculaId: string | null
  descricaoPerfilMatricula: string | null
  principal: boolean
  index: number
}

export type CamposDadosBancariosInvalids = {
  [K in keyof DadosBancarios]: boolean
}

export interface OptionsSelectDadosBancarios {
  tiposConta: TipoConta[]
  bancos: Banco[]
  matriculas: Beneficio[]
  tiposPix: TipoPix[]
}

export interface DadosBancariosReq {
  cpf: string
  contaCorrenteId?: string | null
  numeroAgencia: string | null
  digitoAgencia?: string | null
  numeroConta: string | null
  digitoConta: string | null
  chavePix?: string | null
  tipoPixId?: string | null
  tipoContaId: string
  bancoDadosBancarioId: string
  matriculaId?: string | null
  principal: boolean
}

export interface ConfigTabDadosBancarios {
  visualizacao: boolean
  matriculaId: string
}
